import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {
  GetSettingDTO,
  HttpService,
  ResponseDTO,
  UpdateSettingDTO,
} from '@/shared';

@Service()
export class SettingService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async getSetting(getSettingDTO: GetSettingDTO): Promise<ResponseDTO> {
    return this.httpService.request(getSettingDTO);
  }
  public async updateSetting(
    updateSettingDTO: UpdateSettingDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(updateSettingDTO);
  }
}
